module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921114149_T.eafaadb0.jpg";